import React from "react";
import { formatNumber } from "../../utils/functions";
import { useTranslation } from "react-i18next";

export default function BillSummary({ billSelection }) {
  const billsPerCurrency = billSelection.currency;
  const { t } = useTranslation();

  return (
    <div className="bill-selection-container">
      <div className="total-bill-selection">
        <h4>
          {t("bills.billSummary.totalBillSelection")}{" "}
          {billSelection.totalBillSelection}
        </h4>
      </div>
      <div className="currency-container">
        {Object.keys(billsPerCurrency).map((currency) => {
          return (
            <React.Fragment key={currency}>
              {billsPerCurrency[currency].show && (
                <div>
                  <span>{billsPerCurrency[currency].name}</span>
                  <div>
                    <div className="flex">
                      <p>
                        {t("bills.billSummary.totalBill")}{" "}
                        {billsPerCurrency[currency].totalBillSelection}
                      </p>
                      <p>
                        {t("bills.billSummary.totalAmount")}{" "}
                        {formatNumber(
                          (
                            billsPerCurrency[currency].totalBillAmount / 100
                          ).toFixed(2),
                          billsPerCurrency[currency].symbol
                        )}
                      </p>
                    </div>
                    <div className="flex">
                      <p>
                        {t("bills.billSummary.totalDiscountBill")}{" "}
                        {
                          billsPerCurrency[currency].billTypeSelection.discount
                            .totalBillSelection
                        }
                      </p>
                      <p>
                        {t("bills.billSummary.totalDiscountAmount")}{" "}
                        {formatNumber(
                          (
                            billsPerCurrency[currency].billTypeSelection
                              .discount.totalBillAmount / 100
                          ).toFixed(2),
                          billsPerCurrency[currency].symbol
                        )}
                      </p>
                    </div>
                    <div className="flex">
                      <p>
                        {t("bills.billSummary.totalPaymentMaturityBill")}{" "}
                        {
                          billsPerCurrency[currency].billTypeSelection
                            .paymentMaturity.totalBillSelection
                        }
                      </p>
                      <p>
                        {t("bills.billSummary.totalPaymentMaturityAmount")}{" "}
                        {formatNumber(
                          (
                            billsPerCurrency[currency].billTypeSelection
                              .paymentMaturity.totalBillAmount / 100
                          ).toFixed(2),
                          billsPerCurrency[currency].symbol
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
